module.exports = __webpack_public_path__ + "static/media/comdlg32_539.3abeecb6.ico";